export default __webpack_public_path__ + "d66ffe83c977b19e1c321bd2a890a0f0.svg";